import { VariableKindPrefix } from '../variables.model'

export const isAudiometerVariable = (variableId: string) =>
  variableId.startsWith(`${VariableKindPrefix.AUDIOMETER}_`)
